import { gql } from "@apollo/client";

import {
  AskAiChatMessageFragment,
  ChatSessionMessageReactionFragment,
} from "./get-ask-ai-session-query";

export default gql`
  ${ChatSessionMessageReactionFragment}
  ${AskAiChatMessageFragment}
  mutation createAskAIMessageMutation(
    $chatSessionId: Int
    $meetingId: Int
    $assessmentId: Int
    $assessmentQuestionId: Int
    $message: String!
    $imageUrls: [String!]
    $documentUrls: [String!]
    $messageId: String
    $systemContextMessage: String
    $isIncognito: Boolean
    $skillId: String
  ) {
    sendMessageToChatbot(
      chatSessionId: $chatSessionId
      meetingId: $meetingId
      assessmentId: $assessmentId
      assessmentQuestionId: $assessmentQuestionId
      message: $message
      imageUrls: $imageUrls
      documentUrls: $documentUrls
      messageId: $messageId
      systemContextMessage: $systemContextMessage
      isIncognito: $isIncognito
      skillId: $skillId
    ) {
      chatSession {
        id
        updated
        isIncognito
        isReviewCoordinator
        title
        assessment {
          id
          target {
            id
            name
          }
        }
        assessmentQuestion {
          id
          templateContextId
          title
        }
        meeting {
          id
          title
        }
        reactions {
          edges {
            node {
              ...ChatSessionMessageReactionFragment
            }
          }
        }
        messages {
          edges {
            node {
              ...AskAiChatMessageFragment
            }
          }
        }
      }
    }
  }
`;
